import { useGetAgreementsForQuestionCategoryQuery } from '@/hooks/qna/qna.gql.impl';
import { GetAgreementsForQuestionCategoryQuery } from '@/types/bff/gql-schema';
import { Policy } from '@/types/qna';

const parseAgreements = (agreements: GetAgreementsForQuestionCategoryQuery): Array<Policy> => {
  return agreements.getAgreementsByCategory as Array<Policy>;
};

const useAgreementsForAskQuestionCategory = () => {
  const { data } = useGetAgreementsForQuestionCategoryQuery({}, { select: parseAgreements });
  return { data: data ?? [] };
};

export default useAgreementsForAskQuestionCategory;
